import { DrEntity } from './dr-entity';
import { DrObject, DrObjectType } from './dr-object';

export class ProfileViewModel extends DrObject {

    model: Partial<Profile>;

    constructor(value: Partial<Profile>) {
        super(DrObjectType.PROFILE);
        if (value) {
            this.model = value;
        }
    }
}

export class Profile extends DrEntity {
    attributes: Array<any>;
    content: string;
    corpusHandle: string;
    createdBy: string;
    createdOn: string;
    description: string;
    documentHandle: string;
    handle: string;
    lastComments: string;
    name: string;
    projectHandle: string;
    taskHandle: string;
    visibleInEdiscovery: boolean;

    // off-model display values
    iconClass: string;
    iconColor: string;

    constructor(value?: Partial<Profile>) {
        super(value);
        if (value) {
            Object.assign(this, value);
        }
        this.iconClass = 'fa-align-left';
        this.iconColor = 'color-purple-02';
    }
}
